import { Injectable } from '@angular/core';
import { GuestAccessStore } from '../../../stores/guest-store';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor() {}

  setToken(token: string): void {
    localStorage.setItem('auth_token', token);
  }

  checkToken(): boolean {
    return localStorage.getItem('auth_token') ? true : false;
  }

  getToken(): string | null {
    return localStorage.getItem('auth_token') ? localStorage.getItem('auth_token') : null;
  }

  getTokenAsGuestOrNormal(): string | null {
    let token = '';
    const guestState = GuestAccessStore.getState();
    const normalToken = this.getToken();
    if (normalToken && !guestState.enabled) {
      token = normalToken;
    }

    if (guestState.enabled && guestState.token) {
      token = guestState.token;
    }

    return token || null;
  }

  deleteToken(): void {
    localStorage.removeItem('auth_token');
  }
}
